const sortOptions = [
  {
    label: 'Data dodania (Najnowsze)',
    value: 'created_at_descending',
  },
  {
    label: 'Data dodania (Najstarsze)',
    value: 'created_at_ascending',
  },
  {
    label: 'Ostatnio zmienione',
    value: 'updated_at_descending',
  },
  {
    label: 'Najbliższy termin wykonania',
    value: 'deadline_ascending',
  },
];

export default sortOptions;
